import { useEffect } from 'react';

import { configString } from 'config/appConfigUtils';

const loadedNames = new Set<string>();

export function useLoadBundleCssOnce(name: string | undefined) {
  useEffect(() => {
    if (!name || loadedNames.has(name)) return;

    loadedNames.add(name);

    const styleEl = document.createElement('link');
    styleEl.href = `${configString('idealist', 'staticJsPath')}../${name}.css`;
    styleEl.type = 'text/css';
    styleEl.rel = 'stylesheet';
    document.head.appendChild(styleEl);
  }, [name]);
}
